import { destroyRequestsMarkdown } from './state';
import actions from '../../constants';

export default {
  [actions.DESTROY_REQUESTS]: destroyRequestsMarkdown,
};
